import { Button, Tooltip, Typography } from "@mui/material";
// import DialogModal from "components/Dialog/DialogModal";
// import asset from "json/assets";
import React, { useState } from "react";
import styles from "styles/component/RightList.module.scss";
import stylesPopOver from "styles/component/PopOver.module.scss";
import ListTableContent from "components/ListTableContent/ListTableContent";
import PopperComponent from "components/PopperComponent/PopperComponent";
import { useDispatch } from "react-redux";
import { setSelectedGroup} from "redux/MapSlice";
import { useEditableArea, useSelectedGroup } from "hooks/MapDetails";
import eventEmitter from "services/event.emitter";
import events from "json/events";
import { setEnableMoveMode } from "redux/CourseMapSlice";

export default function BasicControlOption(props) {
  const {
    index,
    icon,
    // isIcon,
    title,
    // isData,
    optionListStyleTwo,
    onClickEvent = () => {},
    data,
    cancelEdit = () => {},
    isActive,
    tooltipText
  } = props;
  //   const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const selectedGroup = useSelectedGroup();
  const editableArea = useEditableArea();
  const handleClick = (e) => {
    eventEmitter.emit("resetMoveMode");
    dispatch(setEnableMoveMode(false));


    // if (!editableArea) { // can not draw scale when in edit mode ~~ temp. solution
      onClickEvent();

      if (title === "Scale") {
        dispatch(setSelectedGroup(title));
      }
    // }
  };

  //   const handleClose = () => {
  //     setAnchorEl(null);

  //   };

  //   const openAnchor = selectedGroup === title && Boolean(anchorEl);
  //   const isData = data ? true : false;

  return (
    <>
      <Tooltip title={tooltipText} arrow placement="left">
        <Button
          onClick={(e) => {
            handleClick(e);
          }}
          aria-describedby={index}
          className={isActive ? styles.active_btn : undefined}
        >
          <span className={styles.icon}>
            <img src={icon} alt="" />
          </span>
        </Button>

        {/* {isData && (
          <PopperComponent
            onClose={() => {
            //   handleClose();
            }}
            handleOnClose={() => {
            //   handleClose();
            }}
            open={openAnchor}
            id={index}
            anchorOpen={anchorEl}
            title={title}
          >
 
            <div className={stylesPopOver.list_icon_table}>
              <ListTableContent
                // isTableStylesTwo={optionListStyleTwo}
                contentData={data}
                cancelEdit={cancelEdit}
              />
            </div>
           
          </PopperComponent>
        )} */}
      </Tooltip>
    </>
  );
}
